var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dialog-base",
    {
      attrs: {
        visible: _vm.visible,
        title: "Hướng dẫn thao tác khoản thu gốc",
        size: "lg",
        "cancel-text": "Đóng",
        "confirm-text": "Đã hiểu",
        "use-panel": false,
        "append-to-body": true,
        top: "6vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        confirm: _vm.handleClose,
        cancel: _vm.handleClose,
      },
    },
    [
      _c("div", { staticClass: "prg-guide" }, [
        _c("div", { staticClass: "prg-section" }, [
          _c("p", { staticClass: "prg-title" }, [_vm._v("1) Thông tin chung")]),
          _c("ul", [
            _c("li", [
              _vm._v("Nhập "),
              _c("strong", [_vm._v("Tên khoản thu")]),
              _vm._v(", chọn "),
              _c("strong", [_vm._v("Loại khoản")]),
              _vm._v(" và "),
              _c("strong", [_vm._v("Đơn vị tính")]),
              _vm._v("."),
            ]),
            _c("li", [
              _vm._v("Dùng "),
              _c("strong", [_vm._v("Mô tả")]),
              _vm._v(" để ghi chú ngắn giúp dễ quản lý và tìm kiếm."),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "prg-section" }, [
          _c("p", { staticClass: "prg-title" }, [_vm._v("2) Tài chính")]),
          _c("ul", [
            _c("li", [
              _vm._v("Nhập "),
              _c("strong", [_vm._v("Đơn giá")]),
              _vm._v(" và "),
              _c("strong", [_vm._v("Số lượng")]),
              _vm._v(" để hệ thống tính thành tiền tham khảo."),
            ]),
            _c("li", [
              _vm._v("Nếu bật "),
              _c("strong", [_vm._v("Giảm giá")]),
              _vm._v(", chọn kiểu giảm theo "),
              _c("strong", [_vm._v("%")]),
              _vm._v(" hoặc theo "),
              _c("strong", [_vm._v("số tiền")]),
              _vm._v("."),
            ]),
            _c("li", [
              _vm._v("Phần "),
              _c("strong", [_vm._v("Thành tiền")]),
              _vm._v(" và "),
              _c("strong", [_vm._v("Số tiền bằng chữ")]),
              _vm._v(" là giá trị preview trên giao diện."),
            ]),
          ]),
          _c("p", { staticClass: "prg-example" }, [
            _vm._v(
              "Ví dụ: Đơn giá 2.000.000, số lượng 1, giảm 10% - thành tiền tham khảo còn 1.800.000."
            ),
          ]),
        ]),
        _c("div", { staticClass: "prg-section" }, [
          _c("p", { staticClass: "prg-title" }, [
            _vm._v("3) Thời gian áp dụng"),
          ]),
          _c("ul", [
            _c("li", [
              _c("strong", [_vm._v("Theo tháng")]),
              _vm._v(
                ": chọn tháng áp dụng và cấu hình chu kỳ cả tháng hoặc theo ngày."
              ),
            ]),
            _c("li", [
              _c("strong", [_vm._v("Theo khoảng ngày")]),
              _vm._v(": chọn ngày bắt đầu và ngày kết thúc."),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "prg-section" }, [
          _c("p", { staticClass: "prg-title" }, [
            _vm._v("4) Cấu hình điểm danh"),
          ]),
          _c("ul", [
            _c("li", [
              _vm._v("Bật "),
              _c("strong", [_vm._v("Áp dụng điểm danh")]),
              _vm._v(" khi cần tính phí/hoàn phí theo dữ liệu điểm danh."),
            ]),
            _c("li", [
              _vm._v("Chọn "),
              _c("strong", [_vm._v("Phương pháp tính")]),
              _vm._v(", "),
              _c("strong", [_vm._v("Loại điểm danh")]),
              _vm._v(" và "),
              _c("strong", [_vm._v("Chi tiết")]),
              _vm._v(" phù hợp."),
            ]),
            _c("li", [
              _vm._v("Nếu chọn "),
              _c("strong", [_vm._v("Đón muộn (LATE)")]),
              _vm._v(
                ", cần cấu hình giờ đón về và các block thời gian tính tiền."
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "prg-note" }, [
          _vm._v(
            "Mẹo: Bạn vẫn có thể rê chuột vào từng biểu tượng dấu hỏi cạnh để xem giải thích nhanh tại chỗ."
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }